import { RouteConfig } from 'react-router-config'
import PrimaryLayout from '@/layouts/PrimaryLayout'
import { withAuthorized } from '@/components/Authorized'
import dashboard from './dashboard'
import ship from './shipments'
import wallet from './wallet'
import account from './account'
import setting from './setting'
import help from './help'
import addressBook from './addressBook'
import track from './track'
import billManagement from './billManagement'
import home from './home'
import survey from './survey'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: withAuthorized(PrimaryLayout),
    routes: [...dashboard, ...ship, ...track, ...billManagement, ...setting, ...wallet, ...account, ...help, ...addressBook, ...home, ...survey],
  },
]

export default routes
